export const Color = {
  GREY: '#5c5c5c',
  MUTED_GREY: '#8d959c',
  BORDER_GREY: '#e8eef2',
  WHITE: 'white',
  BLACK: 'black',
  KIO_ORANGE: '#FF9142',
  HEAVY_GREY: '#d8d8d8',
  LIGHT_GREY: '#f7f7f7',
  GREEN: '#0CAF60',
  RED: '#FF5A5A',
  LIGHT_RED: '#FFEBEB',
  BLUE: '#46ADFF',

  TEXT_STRONG: '#25282b',
  TEXT_BODY: '#6b737a',

  KIO_ORANGE_FAINT: '#FFF3E7',
  GREEN_FAINT: '#EDF9F1',
  BLUE_FAINT: '#E8F5FF',
  KIO_ORANGE_DARK: '#f7842e',
  KIO_ORANGE_ICON_BG: '#FFE7D3',
  BLUE_ICON_BG: '#DCEEFF',
  GREEN_ICON_BG: '#D4F1E1',
  GREY_ICON_BG: '#E5E5E5',
} as const;

export const OnboardingColor = {
  EYEBROW_TEXT: '#8d959c',
  TITLE_TEXT: '#25282b',
  BODY_TEXT: '#4f565b',
  // 본문보다 옅되 읽어야 하는 텍스트용. 흰 배경 대비 4.91:1로 WCAG AA를 넘는 가장 옅은 값이다
  SUBTLE_TEXT: '#697278',
  MUTED_TEXT: '#7b858c',
  STEP_ACTIVE_BORDER: '#ffd7b8',
  STEP_ACTIVE_BG: '#fffaf5',
  STEP_INACTIVE_BORDER: '#e8eef2',
  STEP_INACTIVE_BG: '#ffffff',
  STEP_COMPLETED_BG: '#edf9f1',
  STEP_PENDING_BG: '#fff3e7',
  STEP_IDLE_BORDER: '#d7dde2',
  CONNECTOR_IDLE: '#e8eef2',
} as const;

export type ColorType = typeof Color[keyof typeof Color];
